import { useStore } from 'effector-react'
import {
  $totalCountOfSocialMediaItems,
  socialMediaListMounted,
  getSocialMedia,
  $socialMediaItems,
} from './model'
import { SocialMediaRequest } from './types'

export const useSocialMediaList = () => {
  const onChangeSocialMediaList = ({
    limit,
    page,
    filters,
  }: SocialMediaRequest) => {
    socialMediaListMounted({
      limit,
      page,
      filters,
    })
  }

  const loading = useStore(getSocialMedia.pending)

  const socialMediaItems = useStore($socialMediaItems)
  const totalCountOfSocialMediaItems = useStore($totalCountOfSocialMediaItems)

  return {
    socialMediaItems,
    totalCountOfSocialMediaItems,
    loading,
    onChangeSocialMediaList,
  }
}
